<template>
  <item-box class-suffix="textarea">
    <el-form-item label="ID">
      <el-input v-model="data.fieldId" />
    </el-form-item>
    <el-form-item label="标签">
      <el-input v-model="data.label" />
    </el-form-item>
    <el-form-item label="默认值">
      <el-input v-model="data.defaultValue" />
    </el-form-item>
    <el-form-item label="提示">
      <el-input v-model="data.placeholder" />
    </el-form-item>
    <el-form-item label="必填">
      <el-switch v-model="required" active-text="是" inactive-text="否" />
    </el-form-item>
    <el-form-item v-if="required" label="必填提示">
      <el-input v-model="data.rules.required.message" placeholder="必填提示文本" />
    </el-form-item>
    <regx-add v-model="data.rules" />
  </item-box>
</template>

<script>
import ItemBox from '../../common/setting/ItemBox'
import RegxAdd from '../../common/setting/regx-add'
import Mixins from '../../mixins/check-required'
export default {
  name: 'TextareaSetting',
  components: { ItemBox, RegxAdd },
  mixins: [Mixins],
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>
